export const WarrantyListRouting = [
  {
    path: "/warranty/warranty-list/list",
    name: "warranty-list-list",
    meta: { title: "保修列表" },
    component: () => import("@/views/warranty/warranty-list/list/index.vue"),
  },
];
